(function () {
  'use strict';

  angular.module('app').component('serviceItemPage', serviceItemDetailCtrl());

  function serviceItemDetailCtrl() {
    return {
      bindings: {},
      controller: ServiceItemDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/service-items/service-item-page.component.html',
    };
  }

  ServiceItemDetailCtrl.$inject = [
    '$location',
    '$routeParams',
    'AbilityService',
    'ServiceItemService',
    'LanguageService',
  ];

  function ServiceItemDetailCtrl(
    $location,
    $routeParams,
    AbilityService,
    ServiceItemService,
    LanguageService
  ) {
    let vm = this;

    vm.permissions = {
      canCreate: AbilityService.can('create_serviceitem_accountadmin'),
    };

    let itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.activeTab = $routeParams.activeTab;

    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    // Initializers
    // getServiceItem();
    getDefaultLanguage();

    function getDefaultLanguage() {
      LanguageService.getLanguages({ get: 'is_default', skip_check_role: true }).then(function (
        data
      ) {
        vm.defaultLanguage = data.items.lang;

        getServiceItem();
      });
    }

    function getServiceItem() {
      if (itemId) {
        // Edit
        vm.loadingItem = true;
        ServiceItemService.getServiceItem(itemId, { lang: vm.defaultLanguage }).then(function (
          data
        ) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onSavedItem(item) {
      $location.path(`/service_items/${item.id}`);
    }

    function onCanceledItem() {
      $location.path('/service_items');
    }
  }
})();
